import globalConf from "logic/src/objects/globalConfig/store";

export default globalConf;
